import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useConfig } from '../context/ConfigContext';
import ThemeToggle from './ThemeToggle';

function Navbar() {
  const { user, logout } = useAuth();
  const { getCompanyName, getCompanyLegalName, getLogo, getDisplayBranding } = useConfig();
  const navigate = useNavigate();

  // Get tier-based branding
  const branding = getDisplayBranding();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  // Render the brand based on tier settings
  const renderBrand = () => {
    const companyName = getCompanyName();

    if (branding.type === 'text') {
      // STARTER tier or PRO+ preferring text: Show company name as styled text only
      return (
        <>
          <span className="nav-brand-text nav-brand-text-desktop">{branding.text}</span>
          <span className="nav-brand-text nav-brand-text-mobile">{branding.text}</span>
        </>
      );
    }

    // 'logo' or 'deedstack' type: Show logo + company name side by side
    // For 'logo' type (tenant's custom logo), use their logo for mobile too
    // For 'deedstack' type (free trial), use DeedStack icon for mobile
    const mobileLogoSrc = branding.type === 'logo'
      ? (branding.src || getLogo('icon'))
      : getLogo('icon');

    return (
      <>
        {/* Desktop: Logo + Company Name */}
        <div className="nav-brand-combo">
          <img
            src={branding.src || getLogo('horizontal')}
            alt={getCompanyLegalName()}
            className="nav-logo-desktop"
          />
          <span className="nav-company-name">{companyName}</span>
        </div>
        {/* Mobile: Use tenant's logo if available, otherwise DeedStack icon */}
        <img
          src={mobileLogoSrc}
          alt={companyName}
          className="nav-logo-mobile"
        />
      </>
    );
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-brand">
          {renderBrand()}
        </Link>
        
        <div className="nav-links">
          <Link to="/" className="nav-link">Home</Link>
          <Link to="/properties" className="nav-link">Properties</Link>
          <Link to="/sold-properties" className="nav-link">Recent Sales</Link>
          <Link to="/about" className="nav-link">About</Link>
          <Link to="/contact" className="nav-link">Contact</Link>
          
          {user ? (
            <>
              <Link to="/dashboard" className="nav-link">Dashboard</Link>
              <Link to="/account-settings" className="nav-link">Account Settings</Link>
              <button onClick={handleLogout} className="nav-link btn-logout">
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="nav-link">Login</Link>
              <Link to="/register" className="nav-link btn-register">Sign Up</Link>
            </>
          )}

          {/* This navbar serves BOTH the buyer portal and the public tenant
              storefront, so one control covers a signed-in buyer and an
              anonymous visitor. A buyer's choice saves to their user record; a
              visitor's stays in localStorage, because there is no account to
              save it to. */}
          <ThemeToggle />
        </div>
      </div>
    </nav>
  );
}

export default Navbar;